import { gql, useQuery } from "@apollo/client";

export const useLibraryCategories = (parentId: string = undefined) => {
  return useQuery(gql`
    query getLibraryCategories($filter: FilterFindManyLibraryCategoryInput) {
      library_categories(filter: $filter) {
        _id
        name
        description
        status
        image_id
        image_name
        using_organisation_ids
      }
    }
  `, {
    variables: {
      filter: {
        parent_id: parentId,
      }
    },
    fetchPolicy: "network-only",
  });
};